export default __webpack_public_path__ + "static/media/about2.62ff720d.jpeg";